// extracted by mini-css-extract-plugin
module.exports = {"warning_message":"confirmModal_warning_message__2wv91"};